import React, { useState } from 'react';

import { SelectInput } from '../../../../../components/lib/SelectInput';

const projects = [
  { id: 1, value: 'seller', name: 'Je pense à vendre mon bien et je me renseigne' },
  { id: 2, value: 'buyer', name: "J'achète un bien et je me renseigne" },
  { id: 3, value: 'pro', name: "Je suis un professionnel de l'immobilier" },
  { id: 4, value: 'curious', name: 'Je suis juste curieux sur le marché' }
]

const ProjectInput = ({ formValues, setFormValues, formErrors }) => {
  const [stateProject, setStateProject] = useState();

  const handleChange = (project) => {
    setStateProject(project);
    setFormValues({ ...formValues, project: project.value })
  }

  return (
    <div className='w-full flex flex-col gap-2'>
      <p className='text-white'>Qu'est-ce qui vous amène ?</p>

      <div className='w-full flex flex-col gap-2'>
        <SelectInput name='project' options={projects} selectedOption={stateProject} handleChange={(project) => handleChange(project)} placeholder='Sélectionnez une raison' listHeight='h-full xl:h-32' />
        {formErrors.project && <p className='text-sm text-ih-red'>{formErrors.project}</p>}
      </div>
    </div>
  )
}

export default ProjectInput;
